import React from 'react';
import adZones from '../../data/adZones';
import { connect } from '../../connect';
import { FaithlifeAd } from '../../components/faithlife-ad';
import { getProducts } from '../../actions';
import logger from '../../utils/logger';
import { Suggestion, ISuggestion } from './suggestion';
import './index.less';
import { IProductsState } from '../../reducers/products-reducers';
import { IReduxProps } from '../../actions/action-types';

interface IEndCapProps extends IReduxProps {
	products: IProductsState;
	suggestedVideoEndcap: {
		suggestions: ISuggestion[];
		header: string;
	};
	adParams?: object;
}

interface IEndCapState {
	hasCheckedProducts?: boolean;
	active: string;
}

const activeEndCapClass = 'endcap-active';
const inactiveEndCapClass = 'endcap-inactive';
const maxEndCapSuggestions = 2;

function mapStateToProps({ products }) {
	return { products };
}

function mapDispatchToProps(dispatch) {
	return { dispatch };
}

@connect(mapStateToProps, mapDispatchToProps)
export class EndCap extends React.Component<IEndCapProps, IEndCapState> {
	state: IEndCapState = {
		active: activeEndCapClass,
	};

	componentDidMount() {
		const { suggestedVideoEndcap, dispatch } = this.props;
		const productIds =
			suggestedVideoEndcap && suggestedVideoEndcap.suggestions
				? suggestedVideoEndcap.suggestions.filter(endcap => endcap.productId).map(endcap => endcap.productId)
				: [];
		dispatch(getProducts(productIds)).catch(logger.error);
	}

	componentWillReceiveProps(nextProps: IEndCapProps) {
		if (this.props.products.isProcessing && !nextProps.products.isProcessing) {
			this.setState({ hasCheckedProducts: true });
		}
	}

	_handleCloseButton = () => {
		if (this.state.active === activeEndCapClass) {
			this.setState({ active: inactiveEndCapClass });
		}
	};

	render() {
		const {
			dispatch,
			products: { products },
			suggestedVideoEndcap,
			adParams,
		} = this.props;
		const { active, hasCheckedProducts } = this.state;

		let suggestions;
		const faithlifeAds: JSX.Element[] = [];
		const fullLayoutSuggestion = suggestedVideoEndcap.suggestions.find(suggestion => suggestion.layout === 'full');
		if (fullLayoutSuggestion) {
			suggestions = [fullLayoutSuggestion];
		} else {
			suggestions = suggestedVideoEndcap.suggestions;
			for (let i = 0; i < maxEndCapSuggestions - suggestions.length; i++) {
				faithlifeAds.push(<FaithlifeAd key={i} zone={adZones[i]} params={adParams} />);
				// TODO: Don't rely on there always being 2 adzones and 2 endcap items
			}
		}

		return (
			<div className="end-cap">
				<aside className={active}>
					{/* TODO: Fix this the next time the file is edited. */}
					{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
					<div className="close-button" onClick={this._handleCloseButton}>
						&#x2A09;
					</div>
					<h5 className="header">{suggestedVideoEndcap.header}</h5>
					{hasCheckedProducts ? (
						<div className="container">
							{suggestions.map(suggestion => (
								<Suggestion
									key={suggestion.title}
									suggestion={suggestion}
									product={products ? products.find(product => product.productId === suggestion.productId) : undefined}
									dispatch={dispatch}
								/>
							))}
							{faithlifeAds.length ? faithlifeAds : false}
						</div>
					) : (
						false
					)}
				</aside>
			</div>
		);
	}
}
